import { render, staticRenderFns } from "./UpdateProductName.vue?vue&type=template&id=79e48709&scoped=true&"
import script from "./UpdateProductName.vue?vue&type=script&lang=js&"
export * from "./UpdateProductName.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProductName.vue?vue&type=style&index=0&id=79e48709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e48709",
  null
  
)

export default component.exports